export default __webpack_public_path__ + "static/media/righteous-latin-ext.be7bf01b.woff2";